import React from 'react';
import { Skeleton } from 'antd';
import clsx from 'clsx';

/**
 * A single KPI tile. When `onClick` is set the tile behaves like a filter
 * button (keyboard accessible), and `active` marks the filter currently
 * applied, so the same tiles double as status tabs on list pages.
 *
 * tone: default | primary | success | warning | danger — colours the icon.
 * highlight: also colour the number, for a queue that needs action now.
 */
export const StatCard = ({
  label,
  value,
  icon,
  tone = 'default',
  hint,
  suffix,
  onClick,
  active = false,
  highlight = false,
  loading = false,
}) => {
  const clickable = typeof onClick === 'function';
  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  };
  return (
    <div
      className={clsx('stat-card', `stat-card--${tone}`, {
        'is-clickable': clickable,
        'is-active': active,
        'is-highlight': highlight,
      })}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-pressed={clickable ? active : undefined}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className="stat-card__top">
        <span className="stat-card__label">{label}</span>
        {icon ? <span className="stat-card__icon">{icon}</span> : null}
      </div>
      <div className="stat-card__value">
        {loading ? <Skeleton.Button active size="small" style={{ width: 56 }} /> : value}
        {!loading && suffix ? <span className="stat-card__suffix">{suffix}</span> : null}
      </div>
      {hint ? <div className="stat-card__hint">{hint}</div> : null}
    </div>
  );
};

/** Responsive row of StatCards; tiles wrap once they would get narrower than `min`. */
export const StatGrid = ({ children, min = 180, className }) => (
  <div className={clsx('stat-grid', className)} style={{ '--stat-min': `${min}px` }}>
    {children}
  </div>
);

export default StatCard;
